import { swRequest } from "@sourcewhale/core";

export const sendWhatsApp = (body) =>
  swRequest({
    path: "/api/whatsapp/send",
    method: "POST",
    body,
  });
